import { EntityType, Rights } from '@frontend/common';
import { ObjectDetail } from '@frontend/components/detail';
import { IdentificationClient } from '@frontend/identification/api';
import { Identification, IdentificationType } from '@frontend/identification/types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { useAppDispatch } from '../../redux/store';

const ID = 'identification-detail';

const IdentificationDetail = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const [object, changeObject] = useState<Identification | null>(null);

    return (
        <ObjectDetail<Identification>
            entityType={EntityType.IDENTIFICATION}
            reactive
            fetch={(accountId: string, identificationId: string) => IdentificationClient.fetchIdentification(accountId, identificationId)}
            urlParamKeys={['accountId', 'identificationId']}
            baseRoute='/identifications'
            id={ID}
            dispatch={dispatch}
            objectHeader={(obj) => obj.key}
            order={['key', 'entity_id', ...getRelevantIdentificationColumns(object?.type)]}
            eventListener={EntityType.IDENTIFICATION}
            object={changeObject}
            delete={{
                onDelete: (accountId: string, identificationId: string) => IdentificationClient.deleteIdentification(accountId, identificationId),
                requiredPermissions: (obj) => [
                    { item: EntityType.IDENTIFICATION, source: EntityType.ACCOUNT, right: Rights.DELETE, uid: obj.account_id },
                    { item: EntityType.IDENTIFICATION, source: EntityType.IDENTIFICATION, right: Rights.DELETE, uid: obj.id }
                ],
                propertyName: 'Identification',
                displayName: (obj) => obj.key
            }}
            update={{
                onUpdate: () => navigate('../update'),
                requiredPermissions: (obj) => [
                    { item: EntityType.IDENTIFICATION, source: EntityType.ACCOUNT, right: Rights.UPDATE, uid: obj.account_id },
                    { item: EntityType.IDENTIFICATION, source: EntityType.IDENTIFICATION, right: Rights.UPDATE, uid: obj.id }
                ]
            }}></ObjectDetail>
    );
};

export default IdentificationDetail;

function getRelevantIdentificationColumns(type?: IdentificationType): (keyof Identification)[] {
    switch (type) {
        case IdentificationType.BASIC_AUTH:
            return ['secret'];
        default:
            return [];
    }
}
